export default "__VITE_ASSET__CAN4o7VF__"